import React from 'react';
import { CloseIcon } from 'assets/icons';
import { Button } from 'components';
import { Globals } from 'utils';
import { ServicesService } from 'services';

interface ModalDeleteServiceProps {
  services?: any
  onClose: (reload?: boolean) => void
}

export const ModalDeleteService = ({ services, onClose }: ModalDeleteServiceProps) => {

  const onSubmit = async () => {
    try {
      await ServicesService.delete({ service_id: services.id });
      onClose(true);
      Globals.showSuccess('Servicio eliminado');

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  return (
    <div>
      <header>
        <p className="title">Confirmar</p>
        <button className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <p className="message">¿Está seguro de que desea eliminar este servicio?</p>
      <div className="actions">
        <Button onClick={() => onClose()} clear>Cancelar</Button>
        <Button onClick={onSubmit}>Aceptar</Button>
      </div>
    </div>
  );
}